import { render, staticRenderFns } from "./index_20210301.vue?vue&type=template&id=61a584f2&scoped=true&"
import script from "./index_20210301.vue?vue&type=script&lang=js&"
export * from "./index_20210301.vue?vue&type=script&lang=js&"
import style0 from "@/assets/monitor.less?vue&type=style&index=0&id=61a584f2&lang=less&scoped=true&"
import style1 from "./index_20210301.vue?vue&type=style&index=1&id=61a584f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a584f2",
  null
  
)

export default component.exports